import { render, staticRenderFns } from "./ModalLayouts.vue?vue&type=template&id=2a225a88&scoped=true"
import script from "./ModalLayouts.vue?vue&type=script&lang=js"
export * from "./ModalLayouts.vue?vue&type=script&lang=js"
import style0 from "./ModalLayouts.vue?vue&type=style&index=0&id=2a225a88&prod&scoped=true&lang=css"
import style1 from "./ModalLayouts.vue?vue&type=style&index=1&id=2a225a88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a225a88",
  null
  
)

export default component.exports